import { useState,useContext } from "react";
import { useCurrencyFormat } from "../../../hooks/useCurrencyFormat";
import { usePideFiado } from '../../../hooks/usePideFiado';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import Swal from "sweetalert2";
export const useCalcScreen = () => {

  const {
    addProduct,
    getFiadoProduct,
    getPaymentMethod
  } = usePideFiado();

  const route = useNavigate()

  const {setError,setAlert,checkToken} = useContext(AuthContext);


  const [exchangeData, setExchangeData] = useState({})
  // const [error, setError] = useState({
  //   title: "",
  //   message: "",
  //   active: false
  // })

  const {formatToMoney} = useCurrencyFormat();

  const nextScreen = async (navigation) => {
    checkToken()
    try {
      let exchangeAmount = parseInt(exchangeData.exchangeAmount)
      let minRequest = exchangeData.exchangeRate.minRequestAmount;
      let maxRequest = exchangeData.exchangeRate.maxRequestAmount;
      let originCurrency = exchangeData.originCurrencyId;
      let amount = parseFloat(exchangeData.capturedAmount);
      let exchangeRateId = exchangeData.exchangeRate.id;
      let destinationCurrencyId = exchangeData.destinationCurrencyId;

      if (amount >= minRequest && amount <= maxRequest && exchangeRateId != undefined) {
        let fiadoProducts = await getFiadoProduct(originCurrency, destinationCurrencyId)

        if (fiadoProducts.length == 1) {

          addProduct(fiadoProducts[0].id, 'fiadoProduct');
          let paymentMethods = await getPaymentMethod(originCurrency, destinationCurrencyId, 'PAYMENT_METHOD');
          if (paymentMethods.length == 1) {
            addProduct(paymentMethods[0].id, 'paymentMethod');
            route('/PaymentMethodScreen', {state:{
              originCurrency,
              destinationCurrencyId,
              component: 'PAYMENT_METHOD',
              amount: amount,
              idFiadoFlash: fiadoProducts[0].id,
              exchangeRateId
            }})
          } else {
            route('/PaymentMethodScreen', {state:{
              originCurrency,
              destinationCurrencyId,
              component: 'PAYMENT_METHOD',
              amount: amount,
              idFiadoFlash: fiadoProducts[0].id,
              exchangeRateId
            }})
          }

        } else {
          route('/ProductsScreen', { state:{amount: amount, currency: originCurrency, exchangeRateId: exchangeRateId }});
        };
 
      } else {


        if(exchangeData?.exchangeRate?.originCurrency?.iso == undefined){
          Swal.fire({
            showCloseButton: true,
            title: 'Cantidad Inválida',
            text: `Deber ingresar una cantidad para continuar.`,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#fd6e0d',
            iconColor: "#fd6e0d",
            confirmButtonText: 'Entendido'
          })
          return false;
        }
        Swal.fire({
          showCloseButton: true,
          title: 'Cantidad Inválida',
          text: `Solo puedes puedes realizar un pide con valores entre ${formatToMoney(minRequest)} y ${formatToMoney(maxRequest)} ${exchangeData.exchangeRate.originCurrency.iso}.`,
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          iconColor: "#fd6e0d",
          confirmButtonText: 'Entendido'
        })
    
        // setError({
        //   title: "Cotización inválida",
        //   message: `Solo puedes puedes realizar un pide con valores entre ${formatToMoney(minRequest)} y ${formatToMoney(maxRequest)} ${exchangeData.exchangeRate.originCurrency.iso}`,
        //   active: true
        // })
      }

    } catch (error) {
      console.log(error);
    }

  }

  return {
    exchangeData,
    setError,
    nextScreen,
    setExchangeData
  }
}